import { Logger, LoggerTransformer } from "@identity/utils";
import { inject, injectWithTransform, singleton } from "tsyringe";
import { Consents } from "./types";
import {
  Action,
  CommunicationService,
  eventsRepository,
} from "../CommunicationService";
import { ConsentProviderFactory } from "./consent-provider-factory";

@singleton()
export class OptInService {
  private consentUpdated = false;
  private _trackingAllowed = false;

  get trackingAllowed(): boolean {
    return this._trackingAllowed;
  }

  set trackingAllowed(value: boolean) {
    this._trackingAllowed = value;
  }

  constructor(
    @inject(CommunicationService)
    private communicationService: CommunicationService,
    @injectWithTransform(Logger, LoggerTransformer, "OptInService")
    private logger: Logger,
    @inject(ConsentProviderFactory)
    private consentProviderFactory: ConsentProviderFactory,
  ) {}

  init() {
    this.consentProviderFactory.get().then((consentProvider) =>
      consentProvider.subscribe((consents: Consents) => {
        this.logger.info(
          "Sending consents: ",
          consents,
          "update?",
          this.consentUpdated,
        );
        // CONSENT_UPDATE event is being dispatched when user updated their
        // consents during the same page view.
        if (this.consentUpdated) {
          this.sendConsentsUpdateToAdEngine(consents);
        }

        // Always send CONSENT_READY event as some parts of Fandom system
        // are not aware of new CONSENT_UPDATE event yet.
        // Most likely the implementation is broken anyway and subsequent events
        // are being ignored, but better be safe than sorry.
        this.sendConsentsToAdEngine(consents);

        if (!this.consentUpdated) {
          this.consentUpdated = true;
        }
      }),
    );
  }

  private sendConsentsToAdEngine(consents: Consents): void {
    this.communicationService.emit(
      new Action(eventsRepository.CONSENT_READY, consents),
    );
  }

  private sendConsentsUpdateToAdEngine(consents: Consents): void {
    this.communicationService.emit(
      new Action(eventsRepository.CONSENT_UPDATE, consents),
    );
  }
}
